import { enableInterestRate, renderErrorMessageAcceptZeroValue } from 'common-components/view-logic'

const InterestRateErrorMessages = ({ haveBasicPremiumState, interestRate$ }) => {
  return (
    <div>
      {!enableInterestRate(haveBasicPremiumState, interestRate$)
        ? null
        : renderErrorMessageAcceptZeroValue('error-interest-rate-message')(interestRate$)}
    </div>
  )
}

export default InterestRateErrorMessages
